import React from "react";
import { useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";

import { has } from "../../util";
import { Roles, RolesEnum } from "../../helper";
import { HeaderNavIcons } from "./";

import "../../App.scss";

import MappixLogo from "../../assets/images/MappixLogo.png";

const Header = () => {
  const isNavCollapsed = useSelector((state)=> state.styleData.isNavCollapsed)
  const userData = useSelector((state)=> state.login)
  let arrayRole = [];
  const fun=(type)=>{
    if (has(type, RolesEnum.Admin)) arrayRole.push(Roles.Admin);
    if (has(type, RolesEnum.MappixAdmin)) arrayRole.push(Roles.MappixAdmin);
    if (has(type, RolesEnum.LeadTeacher)) arrayRole.push(Roles.SeniorLeader);
    if (has(type, RolesEnum.Teacher)) arrayRole.push(Roles.Teacher);
  }
  fun(userData.user.userType);

  return (
    <div className="header-bar" >
      {isNavCollapsed && <div style={{marginLeft:"120px"}}><img src={MappixLogo} className="nav-logo" alt="Mappix" style={{ width:"101px",height:"47px" }} /></div>}
      <Grid container>
        <Grid item xs={6} sm={10} md={10} lg={10} />
        <Grid item xs={6} sm={2} md={2} lg={2} className="d-flex" style={{marginLeft:isNavCollapsed?"-140px":"-70px"}}>
          <div className="d-grid"><span className="user">{userData.user.userName}</span>
            {arrayRole.length > 0 && (
              <span className="userRole">
                {arrayRole.map((role, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && ", "}
                    {role.toUpperCase()}
                  </React.Fragment>
                ))}
              </span>
            )}
          </div>
          <HeaderNavIcons />
        </Grid>
      </Grid>
    </div>
  );
}

export { Header };
